import { AlertTriangleIcon } from 'lucide-react';
import { ErrorPageTemplate } from './ErrorTemplate';

export const NotFoundPage = () => {
  return (
    <ErrorPageTemplate
      Icon={AlertTriangleIcon}
      errorCode={404}
      errorMessage="This Page could not be found."
      returnRoutePath={-1}
    />
  );
};
